import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { SpinnerLoader } from 'shared/ui'
import { CHATBOT_NAME_LIMIT } from 'shared/constants/limits'
import { uiStore } from 'shared/store/uiStore'
import { ChatbotStatus } from 'entities/Chatbot'
import { ChatbotProvider, useChatbotContext } from 'pages/chatbot/context'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'

const AgentBookAppointmentProviderLayoutContent = observer(() => {
  const chatbotStore = useChatbotContext()
  const {
    agentBookAppointmentStepsStore,
    model,
    initResources,
    loadChatbot,
    locked,
    isAccessDenied,
  } = chatbotStore
  const { agentId } = useParams()
  const { state: payload } = useLocation()

  useEffect(() => {
    agentBookAppointmentStepsStore.init(Number(agentId))
  }, [agentId])

  useEffect(() => {
    initResources()

    if (!agentId) return
    loadChatbot(Number(agentId))
  }, [agentId])

  useEffect(() => {
    const duplicateFromId = payload?.duplicateId
    if (duplicateFromId) {
      loadChatbot(duplicateFromId, (data) => {
        model.syncOrigin({
          ...data,
          name: `Copy of ${data.name}`.slice(0, CHATBOT_NAME_LIMIT),
          status: ChatbotStatus.Draft,
          is_active: false,
        })
      })
      return
    }

    if (payload) model.syncOrigin(payload)
  }, [payload])

  useEffect(() => {
    if (isAccessDenied) {
      uiStore.changeRouteViaVue({
        path: `/${ChatbotPath.all}`,
      })
    }
  }, [isAccessDenied])

  if (agentBookAppointmentStepsStore.loading || locked) {
    return <SpinnerLoader ariaLabel={'AgentBookAppointmentProviderLayout'} />
  }

  if (isAccessDenied) return null

  return (
    <>
      <Outlet />
    </>
  )
})

export const AgentBookAppointmentProviderLayout = () => (
  <ChatbotProvider>
    <AgentBookAppointmentProviderLayoutContent />
  </ChatbotProvider>
)
